import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { AssignInvoiceCriteriaProvider } from "presentation/store/AssignInvoiceCriteria/AssignInvoiceCriteriaProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { GridStyles } from "presentation/view/components/styled/NbisTable.styled";
import AssignInvoiceCriteriaMaintenance from "presentation/view/section/AssignInvoiceCriteria/AssignInvoiceCriteriaMaintenance";

const AssignInvoiceCriteriaMain = () => {
    return <ANAInfoWrapper permission={Permission.ASSIGN_INVOICE_CRITERIA_MAINTENANCE}>
        <MessageBarWrapper>
            <AssignInvoiceCriteriaProvider>
                <GridStyles />
                <AssignInvoiceCriteriaMaintenance />
            </AssignInvoiceCriteriaProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default AssignInvoiceCriteriaMain;